import React, { useEffect, useState } from 'react'
import { convertAmPm, isEmpty, canParseJSON } from '../../utils'
import { UPLISTING_MAP_HOME_RULES } from '../../constant'
import ViewMoreContent from '../common/ViewMoreContent'
import HotelAirbnbCancelPolicy from './HotelAirbnbCancelPolicy'
import { Popover } from '@mui/material'

interface Props {
  propertyDetail: any
}

const HouseRulesDialog: React.FC<Props> = ({ propertyDetail }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  const open = Boolean(anchorEl)
  const id = open ? 'chat-popover' : undefined
  // const isMobile = windowDimensions.width < 1024
  const [rules, setRules] = useState<any>({})
  const { defaultCheckInTime, defaultCheckOutTime, houseRules, channel, airbnbCancellationPolicies, cancelPolicies } =
    propertyDetail
  const isAirbnb = channel === 'airbnb'
  const checkInTimeToNumber = Number(defaultCheckInTime)
  const checkOutTimeToNumber = Number(defaultCheckOutTime)

  // const isSpecialFormat = pmsType === PMS.UPLISTING || pmsType === PMS.GUEST_SMILES
  useEffect(() => {
    // if (isSpecialFormat || canParseJSON(houseRules)) {
    if (canParseJSON(houseRules)) {
      setRules(JSON.parse(houseRules))
    } else {
      setRules({})
    } // eslint-disable-next-line
  }, [houseRules])

  const handleOpen = (evemt: any) => {
    setAnchorEl(evemt.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }
  const renderCheckinTime = () => {
    if (isAirbnb && checkInTimeToNumber === 0) {
      return 'Check-in is flexible'
    }
    if (checkInTimeToNumber === 25) {
      return 'Check-in from 01:00 (next day)'
    }
    if (isNaN(checkInTimeToNumber)) {
      if (defaultCheckInTime && defaultCheckInTime.toUpperCase() === 'NOT_SELECTED') {
        return ''
      }
      return 'Check-in from ' + defaultCheckInTime
    }
    return 'Check-in from ' + convertAmPm(checkInTimeToNumber)
  }

  const renderCheckoutTime = () => {
    if (!defaultCheckOutTime) {
      return ''
    }
    return `Checkout by ${isNaN(Number(checkOutTimeToNumber)) ? defaultCheckOutTime : convertAmPm(checkOutTimeToNumber)
      }`
  }
  const renderContentCancelPolicy = () => {
    if (!isEmpty(airbnbCancellationPolicies))
      return <HotelAirbnbCancelPolicy airbnbCancellationPolicies={airbnbCancellationPolicies} />
    return (
      <p className={`whitespace-pre-line dtravel-grayscale-700 dtravel-text-14-20`}>
        {cancelPolicies?.key === 'no_defined'
          ? 'Please contact us for more details or if you need to cancel your reservation.'
          : cancelPolicies?.description ||
          'Please contact us for more details or if you need to cancel your reservation.'}
      </p>
    )
  }
  const renderContent = () => {
    return (
      <>
        <p className="dtravel-text-14-20 dtravel-inter-500 dtravel-grayscale-800 mb-2">Check-in and check-out time</p>
        <ul className="list-disc ml-4 lg:ml-6 mb-2">
          <li className="dtravel-inter-400 dtravel-grayscale-700 dtravel-text-14-20 mb-2">{renderCheckinTime()}</li>
          {defaultCheckOutTime && (
            <li className="dtravel-inter-400 dtravel-grayscale-700 dtravel-text-14-20">{renderCheckoutTime()}</li>
          )}
        </ul>
        <p className="dtravel-text-14-20 dtravel-inter-500 dtravel-grayscale-800 mb-0">Cancellation policy</p>
        <ul className="list-disc ml-4 mb-4">
          <li>{renderContentCancelPolicy()}</li>
        </ul>
        {!isEmpty(houseRules) && (
          <>
            <p className="dtravel-text-14-20 dtravel-inter-500 dtravel-grayscale-800 mb-2">House rules</p>
            {!isEmpty(rules) ? (
              <>
                <ul className="list-disc ml-4 lg:ml-6">
                  {Object.keys(rules).map((key: any) => {
                    return (
                      <li key={key} className={'dtravel-inter-400 dtravel-text-14-20 dtravel-grayscale-700'}>
                        {UPLISTING_MAP_HOME_RULES[key][rules[key] ? '1' : '0']}
                      </li>
                    )
                  })}
                </ul>
              </>
            ) : (
              <ViewMoreContent numberOfLine={5}>
                <ul className="list-disc ml-4 lg:ml-6">
                  {houseRules.split('\n').map((v: string, idx: number) => {
                    if (isEmpty(v?.trim())) return null
                    return (
                      <li
                        key={idx}
                        className={'dtravel-inter-400 dtravel-text-14-20 dtravel-grayscale-700 break-word'}
                        dangerouslySetInnerHTML={{ __html: v }}
                      />
                    )
                  })}
                </ul>
              </ViewMoreContent>
            )}
          </>
        )}
      </>
    )
  }

  return (
    <>
      <button className="underline cursor-pointer" onClick={handleOpen}>
        House Rules
      </button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        PaperProps={{
          style: {
            transform: 'translateY(-12px)',
            padding: '16px',
            boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.18)',
            borderRadius: '4px',
            width: '375px',
            height: 'auto',
            maxHeight: '480px',
            overflowY: 'auto',
          },
        }}
      >
        {renderContent()}
      </Popover>
    </>
  )
}

export default HouseRulesDialog
